import type { UserEmailAddress } from 'accelerator-aad/lib/UserEmailAddress';
import { getInsightCountInBuilding } from './getInsightCountInBuilding';

export function getIsInsightsEmptyForCurrentBuilding(emailAddresses: UserEmailAddress[]): boolean {
    const insightCount = getInsightCountInBuilding(emailAddresses);
    return insightCount == 0;
}
